<template>
  <div>
    <div class="card-body p-0 pb-0">
      <div class="float-right pb-1 pt-0">
        <button
          type="button"
          data-toggle="modal"
          data-target="#Modal_tarifas_tarifario"
          class="btn btn-sm btn-primary"
          v-if="
            $store.getters.can(
              'hidrocarburos.tarifarios.tarifaDetalleCreate'
            ) && accion == null
          "
          @click="[limpiarFormulario(), (accion = 1)]"
        >
          <i class="fa fa-plus"></i>
        </button>
        <button
          type="button"
          data-toggle="modal"
          data-target="#Modal_tarifas_tarifario"
          class="btn btn-sm btn-danger"
          v-if="accion == 1"
          @click="[limpiarFormulario(), (accion = null)]"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
    </div>
    <!-- Formulario Crear Detalle de Tarifa -->
    <div class="card border border-default shadow-sm" v-if="accion == 1">
      <div class="card-body p-2">
        <div class="row p-2 pt-2 pb-2 justify-content-center">
          <div class="col-md-3">
            <div class="form-group">
              <label for="fecha_inicio_vigencia">Fecha Inicio Vigencia</label>
              <input
                type="date"
                class="form-control form-control-sm"
                id="fecha_inicio_vigencia"
                v-model="form.fecha_inicio_vigencia"
                :class="
                  $v.form.fecha_inicio_vigencia.$invalid
                    ? 'is-invalid'
                    : 'is-valid'
                "
                @input="validaFechas"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="fecha_fin_vigencia">Fecha Fin Vigencia</label>
              <input
                type="date"
                class="form-control form-control-sm"
                id="fecha_fin_vigencia"
                v-model="form.fecha_fin_vigencia"
                :class="
                  $v.form.fecha_fin_vigencia.$invalid
                    ? 'is-invalid'
                    : 'is-valid'
                "
                @input="validaFechas"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="radicado">Radicado</label>
              <input
                type="text"
                class="form-control form-control-sm"
                id="radicado"
                v-model="form.radicado"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="valor_tarifa">Valor Tarifa</label>
              <input
                type="number"
                class="form-control form-control-sm"
                id="valor_tarifa"
                v-model="form.valor_tarifa"
                :class="
                  $v.form.valor_tarifa.$invalid ? 'is-invalid' : 'is-valid'
                "
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="tiempo_cargue">Tiempo Cargue</label>
              <input
                type="number"
                step="any"
                class="form-control form-control-sm"
                id="tiempo_cargue"
                v-model="form.tiempo_cargue"
                :class="
                  $v.form.tiempo_cargue.$invalid ? 'is-invalid' : 'is-valid'
                "
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="tiempo_descargue">Tiempo Descargue</label>
              <input
                type="number"
                step="any"
                class="form-control form-control-sm"
                id="tiempo_descargue"
                v-model="form.tiempo_descargue"
                :class="
                  $v.form.tiempo_descargue.$invalid ? 'is-invalid' : 'is-valid'
                "
              />
            </div>
          </div>
          <div class="col-md-2 mt-3 pt-3">
            <div class="form-group">
              <button
                type="button"
                class="btn btn-sm btn-primary shadow"
                v-if="!this.$v.form.$invalid"
                @click="save()"
              >
                Guardar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body p-0 table-responsive">
      <table
        class="table table-striped table-bordered table-hover table-sm text-nowrap"
      >
        <thead class="thead-dark">
          <tr>
            <th class="text-center">Estado</th>
            <th class="text-center">Radicado</th>
            <th class="text-center">Valor Tarifa</th>
            <th class="text-center">Tiempo Cargue</th>
            <th class="text-center">Tiempo Descargue</th>
            <th class="text-center">Inicio Vigencia</th>
            <th class="text-center">Fin Vigencia</th>
            <th class="text-center">Acción</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(tarifa, index) in tarifas.data" :key="index">
            <td class="text-center">
              <span
                class="badge"
                :class="tarifa.estado == 1 ? 'badge-success' : 'badge-danger'"
              >
                {{ tarifa.nEstado }}
              </span>
            </td>
            <td class="text-center">
              <div v-if="actualizar_id == index && estado_index == 2">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  v-model="formActualizar.radicado"
                />
              </div>
              <div v-else>
                {{ tarifa.radicado }}
              </div>
            </td>
            <td class="text-center">
              <div v-if="actualizar_id == index && estado_index == 2">
                <input
                  type="number"
                  class="form-control form-control-sm"
                  v-model="formActualizar.valor_tarifa"
                  :class="
                    $v.formActualizar.valor_tarifa.$invalid
                      ? 'is-invalid'
                      : 'is-valid'
                  "
                />
              </div>
              <div v-else>
                {{ tarifa.valor_tarifa }}
              </div>
            </td>
            <td class="text-center">
              <div v-if="actualizar_id == index && estado_index == 2">
                <input
                  type="number"
                  class="form-control form-control-sm"
                  v-model="formActualizar.tiempo_cargue"
                  :class="
                    $v.formActualizar.tiempo_cargue.$invalid
                      ? 'is-invalid'
                      : 'is-valid'
                  "
                />
              </div>
              <div v-else>
                {{ tarifa.tiempo_cargue }}
              </div>
            </td>
            <td class="text-center">
              <div v-if="actualizar_id == index && estado_index == 2">
                <input
                  type="number"
                  class="form-control form-control-sm"
                  v-model="formActualizar.tiempo_descargue"
                  :class="
                    $v.formActualizar.tiempo_descargue.$invalid
                      ? 'is-invalid'
                      : 'is-valid'
                  "
                />
              </div>
              <div v-else>
                {{ tarifa.tiempo_descargue }}
              </div>
            </td>
            <td class="text-center">
              <div v-if="actualizar_id == index && estado_index == 2">
                <input
                  type="date"
                  class="form-control form-control-sm"
                  v-model="formActualizar.fecha_inicio_vigencia"
                  :class="
                    $v.formActualizar.fecha_inicio_vigencia.$invalid
                      ? 'is-invalid'
                      : 'is-valid'
                  "
                />
              </div>
              <div v-else>
                {{ tarifa.fecha_inicio_vigencia }}
              </div>
            </td>
            <td class="text-center">
              <div v-if="actualizar_id == index && estado_index == 2">
                <input
                  type="date"
                  class="form-control form-control-sm"
                  v-model="formActualizar.fecha_fin_vigencia"
                  :class="
                    $v.formActualizar.fecha_fin_vigencia.$invalid
                      ? 'is-invalid'
                      : 'is-valid'
                  "
                />
              </div>
              <div v-else>
                {{ tarifa.fecha_fin_vigencia }}
              </div>
            </td>
            <td>
              <div class="btn-group float-right">
                <button
                  type="button"
                  class="btn btn-sm bg-navy"
                  v-if="estado_index != 2 && tarifa.estado == 1 && $store.getters.can('hidrocarburos.tarifarios.tarifaDetalleEdit')"
                  @click="edit(index)"
                >
                  <i class="fas fa-edit"></i>
                </button>
                <button
                  type="button"
                  class="btn btn-sm bg-success"
                  v-show="
                    !$v.formActualizar.$invalid &&
                      estado_index == 2 &&
                      actualizar_id == index
                  "
                  @click="saveUpdateTarifa(index)"
                >
                  <i class="fas fa-save"></i>
                </button>
                <button
                  class="btn btn-sm bg-danger"
                  v-show="
                    !$v.formActualizar.$invalid &&
                      estado_index == 2 &&
                      actualizar_id == index
                  "
                  @click="cancelTarifa()"
                >
                  <i class="fas fa-trash"></i>
                </button>
              </div>
              <!-- <div
                    class="btn-group"
                    v-if="
                      estado_contable == 2 && id_actualizar_contable !== index
                    "
                  >
                    <button
                      type="button"
                      class="btn bg-navy"
                      disabled
                      @click="editContable(index)"
                    >
                      <i class="fas fa-edit"></i>
                    </button>
                    <button
                      class="btn bg-danger"
                      disabled
                      @click="destroyContable(index)"
                    >
                      <i class="fas fa-trash"></i>
                    </button>
                  </div> -->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="card-footer border border-default">
      <div class="float-left" v-if="tarifas.total">
        Mostrando del <b>{{ tarifas.from }}</b> al <b>{{ tarifas.to }}</b> de un
        total: <b>{{ tarifas.total }}</b> Registros
      </div>
      <div class="float-left" v-else>
        <span class="badge badge-danger">
          No hay registros para mostrar
        </span>
      </div>
      <div class="float-right">
        <pagination
          :data="tarifas"
          @pagination-change-page="getIndex"
          :limit="5"
        ></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import pagination from "laravel-vue-pagination";
import { required } from "vuelidate/lib/validators";

export default {
  name: "TarifaDetalleTarifario",
  components: {
    pagination,
  },

  data() {
    return {
      tarifas: {},
      accion: null,
      tarifa_contrato_hidrocarburo_id: null,
      actualizar_id: -1,
      estado_index: -1,
      formActualizar: {},
      form: {
        id: null,
        tarifa_contrato_hidrocarburo_id: null,
        radicado: null,
        valor_tarifa: null,
        tiempo_cargue: null,
        tiempo_descargue: null,
        fecha_inicio_vigencia: null,
        fecha_fin_vigencia: null,
      },
    };
  },

  validations: {
    form: {
      valor_tarifa: {
        required,
      },
      tiempo_cargue: {
        required,
      },
      tiempo_descargue: {
        required,
      },
      fecha_inicio_vigencia: {
        required,
      },
      fecha_fin_vigencia: {
        required,
      },
    },

    formActualizar: {
      valor_tarifa: {
        required,
      },
      tiempo_cargue: {
        required,
      },
      tiempo_descargue: {
        required,
      },
      fecha_inicio_vigencia: {
        required,
      },
      fecha_fin_vigencia: {
        required,
      },
    },
  },

  methods: {
    getModal(tarifa_id) {
      this.tarifa_contrato_hidrocarburo_id = tarifa_id;
      this.getIndex();
      this.limpiarFormulario();
    },

    getIndex(page = 1) {
      this.tarifas = {};
      axios
        .get("/api/hidrocarburos/tarifarios/detalleTarifa?page=" + page, {
          params: {
            tarifa_contrato_hidrocarburo_id: this
              .tarifa_contrato_hidrocarburo_id,
          },
        })
        .then((response) => {
          this.tarifas = response.data;
        });
    },

    validaFechas() {
      if (this.form.fecha_inicio_vigencia && this.form.fecha_fin_vigencia) {
        const fecha_menor = new Date(this.form.fecha_inicio_vigencia);
        const fecha_mayor = new Date(this.form.fecha_fin_vigencia);
        // Se valida que la fecha inicial sea menor que la fecha final
        if (fecha_menor > fecha_mayor) {
          this.form.fecha_fin_vigencia = null;
          this.$swal({
            icon: "error",
            title: `La Fecha inicio vigencia no puede ser mayor a la Fecha fin vigencia...`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      }

      // Validar que la fecha de inicio no sea menor a la fecha final de la última tarifa
      this.validarFechaInicioConUltimaTarifa();
    },

    validarFechaInicioConUltimaTarifa() {
      if (
        this.form.fecha_inicio_vigencia &&
        this.tarifas.data &&
        this.tarifas.data.length > 0
      ) {
        // Buscar la tarifa con la fecha de fin más reciente
        const ultimaTarifa = this.tarifas.data.reduce((latest, current) => {
          const latestDate = new Date(latest.fecha_fin_vigencia);
          const currentDate = new Date(current.fecha_fin_vigencia);
          return currentDate > latestDate ? current : latest;
        });

        if (ultimaTarifa.fecha_fin_vigencia) {
          const fechaInicioNueva = new Date(this.form.fecha_inicio_vigencia);
          const fechaFinUltima = new Date(ultimaTarifa.fecha_fin_vigencia);

          // Si la fecha de inicio es menor o igual a la fecha fin de la última tarifa
          if (fechaInicioNueva <= fechaFinUltima) {
            this.form.fecha_inicio_vigencia = null;
            this.$swal({
              icon: "error",
              title: "Fecha de inicio inválida",
              text: `La fecha de inicio debe ser posterior a la fecha de fin de la última tarifa (${ultimaTarifa.fecha_fin_vigencia})`,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
            });
          }
        }
      }
    },

    limpiarFormulario() {
      this.actualizar_id = -1;
      this.estado_index = -1;
      this.formActualizar = {};
      this.form = {
        id: null,
        tarifa_contrato_hidrocarburo_id: this.tarifa_contrato_hidrocarburo_id,
        radicado: null,
        valor_tarifa: null,
        tiempo_cargue: null,
        tiempo_descargue: null,
        fecha_inicio_vigencia: null,
        fecha_fin_vigencia: null,
      };
    },

    save() {
      if (!this.$v.form.$invalid) {
        this.$parent.$parent.cargando = true;

        axios({
          method: "POST",
          url: "/api/hidrocarburos/tarifarios/detalleTarifaSave",
          data: this.form,
        })
          .then((res) => {
            this.$parent.$refs.closeModalDetalleTarifa.click();
            this.limpiarFormulario();
            this.$swal({
              icon: "success",
              title: "El detalle de la tarifa se guardó exitosamente...!",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
            });
            this.getIndex();
            this.$parent.$parent.cargando = false;
          })
          .catch((e) => {
            this.$swal({
              icon: "error",
              title:
                "Ha ocurrido un error, por favor intente la acción nuevamente." +
                e,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            this.$parent.$parent.cargando = false;
          });
      }
    },

    cancelTarifa() {
      this.actualizar_id = -1;
      this.estado_index = -1;
      this.formActualizar = {};
    },

    edit(index) {
      this.limpiarFormulario();
      this.actualizar_id = index;
      this.estado_index = 2;
      this.formActualizar = { ...this.tarifas.data[index] };
    },

    saveUpdateTarifa() {
      if (!this.$v.formActualizar.$invalid) {
        this.$parent.$parent.cargando = true;
        axios({
          method: "POST",
          url: "/api/hidrocarburos/tarifarios/detalleTarifaSave",
          data: this.formActualizar,
        })
          .then(() => {
            this.$parent.$refs.closeModalDetalleTarifa.click();
            this.limpiarFormulario();
            this.$swal({
              icon: "success",
              title: "La detalle de la tarifa se actualizo exitosamente...!",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
            });
            this.getIndex();
            this.$parent.$parent.cargando = false;
          })
          .catch((e) => {
            this.$swal({
              icon: "error",
              title:
                "Ha ocurrido un error, por favor intente la acción nuevamente." +
                e,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            this.$parent.$parent.cargando = false;
          });
      }
    },
  },
};
</script>
